import { getReqUrl } from "@/api";

export const fetchImage = (name: string) => {
  return getReqUrl("/picture", { name });
};
